// ====================================
// imports
// ====================================

import { logger } from './serviceworker.logging';
logger.log('note', 'mainthread console initialized!');

import { LosslessServiceWorker } from './lele-serviceworker.classes.serviceworker';


export const getServiceWorker = async() => {
  const losslessServiceWorkerInstance = await LosslessServiceWorker.createServiceWorker(); // lets setup the service worker
  logger.log('ok', 'service worker ready!'); // and wait for it to be ready
  return losslessServiceWorkerInstance;
};
